import { Component } from '@angular/core';

@Component({
    selector: 'small-screen-modal',
    templateUrl: './small-screen-modal.component.html',
    standalone: false
})
export class SmallScreenModalComponent {}
